import { useLocation, useMatch } from "react-router";
import { CHAT_PATH, getChatHistoryTab } from "../chatRoutes";

const CANONICAL_CHAT_ID = /^[1-9]\d{0,9}$/;
const MAX_CHAT_ID = 2_147_483_647;

/** Return `raw` when it is a canonical positive int32 chat id, else `null`. */
export function canonicalChatId(raw: string): string | null {
    return CANONICAL_CHAT_ID.test(raw) && Number(raw) <= MAX_CHAT_ID
        ? raw
        : null;
}

function useChatRouteSegment(): string | undefined {
    const { pathname } = useLocation();
    const chatId = useMatch(`${CHAT_PATH}/:chatId`)?.params.chatId;
    return getChatHistoryTab(pathname) === null ? chatId : undefined;
}

/** Return the canonical thread id in the chat path, or `undefined` on a reserved or malformed segment. */
export function useChatRouteThreadId(): string | undefined {
    const segment = useChatRouteSegment();
    return segment === undefined
        ? undefined
        : (canonicalChatId(segment) ?? undefined);
}

/** Report whether the chat path names a thread whose id is not canonical. */
export function useIsUnknownChatRoute(): boolean {
    const segment = useChatRouteSegment();
    return segment !== undefined && canonicalChatId(segment) === null;
}
